import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const FaqAccordion = ({ accordionItems }) => {
  const [activeIndices, setActiveIndices] = useState([]);

  const toggleAccordion = (index) => {
    setActiveIndices((prevIndices) =>
      prevIndices.includes(index) ? prevIndices.filter((i) => i !== index) : [...prevIndices, index]
    );
  };

  return (
    <div>
      <div className="flex flex-col gap-2 max-w-3xl mx-auto">
        {accordionItems.map((accordion, index) => (
          <div key={index} className="rounded-2xl overflow-hidden bg-grey-25">
            <button
              onClick={() => toggleAccordion(index)}
              className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50"
            >
              <span className="font-medium flex-1">{accordion.question}</span>
              <motion.div
                className="bg-white rounded-full p-1 flex items-center"
                initial={false}
                animate={{ rotate: activeIndices.includes(index) ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                <ChevronDownIcon className="w-5 h-5" />
              </motion.div>
            </button>

            <AnimatePresence>
              {activeIndices.includes(index) && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-4 pb-4">
                    <p className="text-gray-600">{accordion.answer}</p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqAccordion;
